import { render } from "./PatientFormBanner.vue?vue&type=template&id=64d5b516&scoped=true"
import script from "./PatientFormBanner.vue?vue&type=script&lang=js"
export * from "./PatientFormBanner.vue?vue&type=script&lang=js"

import "./PatientFormBanner.vue?vue&type=style&index=0&id=64d5b516&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d5b516"]])

export default __exports__